import plural from 'helpers/plural';

import featureNames from 'constants/feature_names';

angular.module('gym.subscriptions').controller('SubscriptionPlansCtrl', ["$scope", "$rootScope", "$stateParams", "$state", "$http", "$window", "$filter", "$timeout", "$modal", "$q", "flash", "isInteger", "MessageService", "loadingAnimation", "subscriptionPlans", "FreeTrialRemindMessageText", "GTMService", "AdminUserService", "FeatureAvailabilityService", "ReactModal", function($scope, $rootScope, $stateParams, $state, $http, $window, $filter, $timeout, $modal, $q, flash, isInteger, MessageService, loadingAnimation, subscriptionPlans, FreeTrialRemindMessageText, GTMService, AdminUserService, FeatureAvailabilityService, ReactModal) {
  var confirmFreePlan, confirmSelectPlan, formatPrice, gym, isCurrentPlan, parsePlans, planId, selectPlan, validateChangePlan;
  $scope.adminHasPermission = AdminUserService.has;
  $scope.planData = subscriptionPlans.plan_data;
  $scope.gymData = subscriptionPlans.gym_data;
  $scope.gym = gym = $rootScope.gym;
  $scope.pageParams = {};
  $scope.featureNotAvailable = $stateParams.feature_not_available;
  $scope.isMartialArts = $rootScope.gym.is_martial_arts;
  $scope.featureNames = featureNames;
  GTMService.trackPage('Subscription Plans');
  parsePlans = function(plans, annual) {
    return _.chain(plans).map(function(val, key) {
      if (annual && val === 0) {
        return false;
      }
      return {
        key: annual ? `${key}_annual` : key,
        price: val,
        plan_name: $scope.planData.plan_name_map[key],
        id: planId(key, annual),
        sms_limit: $scope.planData.sms_limits[key],
        sms_fee: $scope.planData.sms_fees[key],
        member_limit: $scope.planData.member_limits[key],
        user_limit: $scope.planData.user_limits[key],
        location_limit: $scope.planData.location_limits[key],
        waiver_limit: $scope.planData.waiver_limits[key],
        style_limit: $scope.planData.style_limits[key],
        report_limit: $scope.planData.report_limits[key],
        features: $scope.planData.features[key]
      };
    }).compact().sortBy(function(item) {
      return item.price;
    }).value();
  };
  planId = function(key, annual) {
    var planKey;
    planKey = annual ? `${key}_annual` : key;
    return $scope.planData.plan_id_map[planKey];
  };
  $scope.plans = {
    monthly: parsePlans($scope.planData.monthly),
    annual: parsePlans($scope.planData.annual, true)
  };
  $scope.getPlans = function() {
    return $scope.plans[$scope.pageParams.selectedFrequency];
  };
  $scope.hasGrandfatheredPlan = function() {
    var plan;
    plan = _.find($scope.getPlans(), function(item) {
      return $scope.gymData.plan_id === item.key;
    });
    return plan && $scope.gymData.gym_has_selected_plan && $scope.gymData.grandfathered_pricing;
  };
  $scope.showGrandfatheredPlanMessage = function() {
    return ReactModal.open({
      component: 'GrandfatheredPricingPlanModal'
    });
  };
  $scope.hasFreeSmses = function() {
    return _.find($scope.getPlans(), function(plan) {
      return $scope.currentValue(plan, 'sms_limit');
    });
  };
  $scope.setFrequency = function(frequency) {
    return $scope.pageParams.selectedFrequency = frequency;
  };
  if ($scope.gymData.subscription_payment_frequency === 'monthly') {
    $scope.setFrequency('monthly');
  } else {
    $scope.setFrequency('annual');
  }
  $scope.isCurrentPlan = isCurrentPlan = function(plan) {
    return plan.key === $scope.gymData.plan_id;
  };
  formatPrice = function(val) {
    if (isInteger(val)) {
      return val;
    } else {
      return (+val).toFixed(2);
    }
  };
  $scope.planPrice = function(plan) {
    if (isCurrentPlan(plan) && isInteger($scope.gymData.subscription_payment_amount)) {
      return parseInt($scope.gymData.subscription_payment_amount, 10);
    } else {
      return formatPrice(plan.price);
    }
  };
  $scope.finalPrice = function(plan) {
    var price;
    price = +$scope.planPrice(plan) - (+$scope.gymData.total_discount_amount);
    if (price > 0) {
      return formatPrice(price);
    } else {
      return 0;
    }
  };
  $scope.planLimit = function(plan, key) {
    if (isCurrentPlan(plan) && $scope.gymData[key]) {
      return $scope.gymData[key];
    } else {
      return plan[key] || 'Unlimited';
    }
  };
  $scope.waiverLimit = function(plan) {
    var limit, styles;
    limit = $scope.planLimit(plan, 'waiver_limit');
    if (limit === 'Unlimited') {
      return '(unlimited Waivers)';
    } else {
      styles = $filter('pluralize')('Waiver', limit, true);
      return `(max. ${styles})`;
    }
  };
  $scope.styleLimit = function(plan) {
    var limit, styles;
    limit = $scope.planLimit(plan, 'style_limit');
    if (limit === 'Unlimited') {
      return '(unlimited Styles)';
    } else {
      styles = $filter('pluralize')('Style', limit, true);
      return `(max. ${styles})`;
    }
  };
  $scope.currentValue = function(plan, field) {
    if (isCurrentPlan(plan) && $scope.gymData[field]) {
      return $scope.gymData[field];
    } else {
      return plan[field];
    }
  };
  $scope.displaySmsesSent = function(plan) {
    var gymData;
    gymData = $scope.gymData;
    return isInteger(gymData.smses_sent_this_month) && gymData.plan_id === plan.id && gymData.gym_has_selected_plan;
  };
  $scope.smsFee = function(plan) {
    if (isCurrentPlan(plan)) {
      return $scope.gymData.per_sms_cost_cents || 0;
    } else {
      return plan.sms_fee;
    }
  };
  $scope.planFeatures = function(plan) {
    if (isCurrentPlan(plan)) {
      return $scope.gymData.features || plan.features;
    } else {
      return plan.features;
    }
  };
  $scope.includesFeature = function(plan, feature) {
    return _.contains($scope.planFeatures(plan), feature);
  };
  $scope.isFeatureEnabled = function(feature) {
    return _.contains($scope.gym.features_enabled, feature);
  };
  selectPlan = function(plan) {
    var params, url;
    GTMService.push({
      event_action: 'Subscription Plan Changed',
      event_category: 'Lifecycle Event',
      event: 'custom_event'
    });
    GTMService.trackPage('Subscription Plans', 'Select a plan');
    url = `/subscriptions/${window.currentUser.id}?gym_id=${$stateParams.gymId}`;
    params = {
      braintree_customer: {
        plan: plan.id
      }
    };
    loadingAnimation.show();
    return $http.put(url, params).then(function() {
      url = $state.href('gym.subscription.tab', {
        tab: 'subscriptions'
      });
      return $window.open(url, '_self');
    }, function(response) {
      var error, ref, ref1;
      loadingAnimation.hide();
      error = (ref = response.data.errors) != null ? (ref1 = ref.plan) != null ? ref1[0] : void 0 : void 0;
      return flash.error = error || "There was an error processing the request.";
    });
  };
  confirmSelectPlan = function(plan, warnings) {
    var currency, currentFrequency, currentPlan, currentPrice, discount, finalCurrentPrice, finalNewPrice, modalInstance, newFrequency, newPlan;
    discount = parseFloat($scope.gymData.total_discount_amount);
    currency = $scope.planData.currency_symbol;
    currentPrice = parseFloat($scope.gymData.subscription_payment_amount);
    finalCurrentPrice = discount ? currentPrice - discount : currentPrice;
    currentFrequency = $scope.gymData.plan_id.indexOf('annual') > -1 ? 'yr' : 'mo';
    currentPlan = `${$scope.gymData.plan_name} (${currency}${finalCurrentPrice}/${currentFrequency})`;
    newFrequency = plan.id.indexOf('annual') > -1 ? 'yr' : 'mo';
    finalNewPrice = discount ? plan.price - discount : plan.price;
    newPlan = `${plan.plan_name} (${currency}${finalNewPrice}/${newFrequency})`;
    if ($scope.gymData.gym_has_selected_plan) {
      modalInstance = $modal.open({
        template: require('templates/gyms/subscriptions/confirm_plan_change_modal.html.slim'),
        controller: 'ConfirmPlanChangeModalCtrl',
        resolve: {
          currentPlan: function() {
            return currentPlan;
          },
          newPlan: function() {
            return newPlan;
          },
          warnings: function() {
            return warnings;
          }
        }
      });
      return modalInstance.result.then(function(data) {
        return selectPlan(plan);
      });
    } else {
      return selectPlan(plan);
    }
  };
  confirmFreePlan = function(plan) {
    var daysLeft, message, params;
    daysLeft = plural('days', $scope.gymData.trial_days_left_count, true);
    message = $scope.gymData.plan_name === 'Established' ? [`${window.currentUser.first_name}, you still have ${daysLeft} left on your free trial, which gives you access to ALL features available on the Established Plan (our top plan!)`, `If you switch now, you will lose access to awesome features such as waivers and ${featureNames.SEQUENCE_PLURAL_LOWERCASE}, and limit the number of active members you can add and manage in your account.`] : [`${window.currentUser.first_name}, you still have ${daysLeft} left on your free trial, which gives you access to all features available on the ${$scope.gymData.plan_name} Plan.`, "If you switch now, you will lose access to these features, and limit the number of active members you can add and manage in your account."];
    params = {
      title: 'Are you sure you want to switch to the Free Plan?',
      message: message,
      confirmButtonText: "Yes, I'd like to switch to the Free Plan",
      cancelButtonText: `No, keep trialling the ${$scope.gymData.plan_name} Plan features!`,
      size: 'lg'
    };
    return MessageService.message(params).then(function() {
      return selectPlan(plan);
    });
  };
  validateChangePlan = function(plan) {
    var deferred, url;
    $scope.pageParams.validatingPlanChange = true;
    deferred = $q.defer();
    url = `/subscriptions/${gym.id}/validate_plan_change?plan=${plan.id}`;
    $http.get(url).then(function(response) {
      deferred.resolve(response.data.warnings);
      return $scope.pageParams.validatingPlanChange = false;
    }, function(response) {
      $scope.pageParams.validatingPlanChange = false;
      return $modal.open({
        template: require('templates/gyms/subscriptions/plan_change_disallowed_modal.html.slim'),
        controller: 'PlanChangeDisallowedModalCtrl',
        resolve: {
          errors: function() {
            return response.data.errors;
          }
        }
      });
    });
    return deferred.promise;
  };
  $scope.selectPlan = function(plan) {
    if ($scope.pageParams.validatingPlanChange) {
      return;
    }
    return validateChangePlan(plan).then(function(warnings) {
      var frequency, isSameFrequency, message, selectedFrequency, subscriptionFrequency, title;
      subscriptionFrequency = $scope.gymData.subscription_payment_frequency;
      selectedFrequency = $scope.pageParams.selectedFrequency;
      isSameFrequency = selectedFrequency === subscriptionFrequency;
      frequency = $filter('capitalize')(selectedFrequency);
      switch (false) {
        case !($scope.gym.on_trial_period && !plan.price):
          return confirmFreePlan(plan);
        case !($scope.gym.on_trial_period || isSameFrequency):
          return confirmSelectPlan(plan, warnings);
        default:
          message = `Please contact us directly at support@clubworx.com if you would like to change to ${frequency} pricing.`;
          title = "Change Plan";
          return MessageService.message({
            title: title,
            message: message
          });
      }
    });
  };
  $scope.togglePopover = function(event) {
    return $timeout(function() {
      event.currentTarget.focus();
      return true;
    });
  };
  $scope.isFreeTrialRemindMessageAvailable = $scope.gym.on_trial_period && $scope.gym.trialling_highest_plan;
  return $scope.freeTrialReminderMessage = FreeTrialRemindMessageText.getMessageForBillingPage('Established');
}]);
